// extracted by mini-css-extract-plugin
module.exports = {"tag-selector":"tag-selector--PNnwlRj0","tag-selector-disable":"tag-selector-disable--1awkfCDh"};